import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CalendarComponent from "../leave/CalendarComponent";
import MyCalendar from "../leave/MyCalendar";
import AdminLeave from "../leave/AdminLeave";

const Leave = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const userRole = useSelector((state) => state.user.role);
  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;
  const isDesktop = windowWidth >= 1024;
  const getMainContentClasses = () => {
    if (isMobile) {
      // On mobile, always use minimal margin regardless of sidebar state
      return "ml-0 px-2 sm:px-4";
    } else if (isTablet) {
      // On tablet, use smaller margins
      return isSideBarOpen ? "ml-16 md:ml-80" : "ml-12 md:ml-24";
    } else {
      // Desktop behavior (your original logic but refined)
      return isSideBarOpen ? "ml-20 lg:ml-80" : "ml-16 md:ml-24";
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="flex">
      {/* Sidebar */}

      {/* Main Content */}
      <div
        className={`flex-1 bg-white transition-all duration-300 ease-in-out ${getMainContentClasses()}`}
      >
        {/* Content */}
        <div className="p-4 border-b-2 border-gray-300">
          {/* Calendar Component */}
          <CalendarComponent />
        </div>
        <div className="p-4 border-b-2 border-gray-300">
          {/* Calendar Component */}
          {/* <MyCalendar /> */}
        </div>

        {/* Display AdminLeave component for both SuperAdmin and Admin */}
        {(userRole === "superadmin" || userRole === "admin") && (
          <div className="p-4 border-b-2 border-gray-300">
            {/* AdminLeave content */}
            <AdminLeave />
          </div>
        )}
      </div>
    </div>
  );
};

export default Leave;
